const FaqToggle = () => {

  const faqElement = document.querySelectorAll('.faqOpener');

  faqElement.forEach(el => {
    el.addEventListener('click', () => {

      const arrow = el.querySelector('.open_arrow');
      const description = el.nextElementSibling;
      if (description.classList.contains('hidden')) {

        arrow.classList.add('rotate-180', 'mr-1');

      }
      else {

        arrow.classList.remove('rotate-180', 'mr-1');

      }
      description.classList.toggle('hidden');
    });
  });
}

export default FaqToggle();